import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs'
import SuccessAlert from '../../../components/Alerts/SuccessAlert'
import FailAlert from '../../../components/Alerts/FailAlert'
import useStore from '../../../store/useStore'
import { t } from 'i18next'
import { useMutation, useQuery } from '@apollo/client'
import { ALL_WORKERS, UpdateWorker, Worker } from '../../../graphql'
import { useParams } from 'react-router-dom'
import { FetchWorker } from '../../../types'
import PermissionsError from '../../../components/Alerts/PermissionsError'
import LoadingWidget from '../../../components/LoadingWidget/LoadingWidget'

const EditWorker = () => {
  const { workerId } = useParams();

  const storeData = useStore((state: any) => state.userData.store);
  const userData = useStore((state: any) => state.userData);

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [permissions, setPermissions] = useState({
    edit: false,
  })

  // Permission configuration
  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      // admin
      if (userData.permissions.length === 0 && userData.role === "admin") {
        setPermissions({
          edit: true,
        })

        setInitialLoading(false)
        return
      }

      setInitialLoading(false)
    }
  }, [userData])

  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  // permissions
  const initPermissions = [
    {
      name: "Products",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        },
        /* {
          name: "publish",
          selected: false,
        },
        {
          name: "hide",
          selected: false,
        },
        {
          name: "view",
          selected: false,
        },
        {
          name: "review",
          selected: false,
        }, */
      ]
    },
    {
      name: "orders",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        },
        {
          name: "view",
          selected: false,
        },
        /* {
          name: "view details",
          selected: false,
        },
        {
          name: "status",
          selected: false,
        }, */
      ]
    },
    {
      name: "clients",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        }/* ,
        {
          name: "view",
          selected: false,
        } */
      ]
    },
    {
      name: "categories",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        }
      ]
    },
    {
      name: "brands",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        }
      ]
    },
    {
      name: "marketing",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "view",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        }
      ]
    },
    {
      name: "settings",
      selected: false,
      options: [
        {
          name: "view settings",
          selected: false,
        },
        {
          name: "store settings",
          selected: false,
        },
        {
          name: "view payment methods",
          selected: false,
        },
        {
          name: "view shipping methods",
          selected: false,
        },
        {
          name: "store design",
          selected: false,
        },
        {
          name: "team work",
          selected: false,
        },
        {
          name: "domain",
          selected: false,
        },
        {
          name: "plugins",
          selected: false,
        },
        {
          name: "additional settings",
          selected: false,
        },
        {
          name: "notification",
          selected: false,
        },
        {
          name: "SEO",
          selected: false,
        },
        {
          name: "bill settings",
          selected: false,
        }
      ]
    },
    {
      name: "report",
      selected: false,
      options: [
        {
          name: "view",
          selected: false,
        }
      ]
    },
    {
      name: "affiliate marketing",
      selected: false,
      options: [
        {
          name: "create",
          selected: false,
        },
        {
          name: "edit",
          selected: false,
        },
        {
          name: "view",
          selected: false,
        },
        {
          name: "delete",
          selected: false,
        }
      ]
    },
  ]

  const [permissionData, setPermissionData] = useState(initPermissions)

  const [checkAll, setCheckAll] = useState(false);

  const handlePermissionSelect = (permissionIndex: any) => {
    const updatedPermissions = [...permissionData];
    updatedPermissions[permissionIndex].selected = !updatedPermissions[permissionIndex].selected;

    // Update the selected status of child options
    updatedPermissions[permissionIndex].options.forEach((option) => {
      option.selected = updatedPermissions[permissionIndex].selected;
    });

    setPermissionData(updatedPermissions);
  };

  const handlePermissionOptionSelect = (permissionIndex: any, optionIndex: any) => {
    const updatedPermissions = [...permissionData];
    updatedPermissions[permissionIndex].options[optionIndex].selected = !updatedPermissions[permissionIndex].options[optionIndex].selected;

    // If all children are deselected, uncheck the parent
    if (!updatedPermissions[permissionIndex].options.some((option) => option.selected)) {
      updatedPermissions[permissionIndex].selected = false;
    } else {
      updatedPermissions[permissionIndex].selected = true;
    }

    setPermissionData(updatedPermissions);
  };

  const handleCheckAll = () => {
    const allSelected = !checkAll;

    const updatedPermissions = permissionData.map((permission) => ({
      ...permission,
      selected: allSelected,
      options: permission.options.map((option) => ({ ...option, selected: allSelected }))
    }));
    setPermissionData(updatedPermissions);
    setCheckAll(allSelected);
  };

  useEffect(() => {
    const allOptionsSelected = permissionData.every((permission) =>
      permission.options.every((option) => option.selected)
    );

    const allParentsSelected = permissionData.every((permission) => permission.selected);

    // If all children and parents are selected, set "Check All" to true
    setCheckAll(allOptionsSelected && allParentsSelected);
  }, [permissionData]);

  const { data: workerData, loading: WorkerLoading } = useQuery<FetchWorker>(Worker, {
    variables: { workerId: workerId }
  });

  useEffect(() => {
    if (workerData) {
      setName(workerData.worker.name)
      setPhone(workerData.worker.phone)
      setEmail(workerData.worker.email)

      const updatedPermissions = initPermissions.map((page) => {
        const pageDataFromBackend = workerData.worker.permissions.find((data) => data.name === page.name);

        return {
          ...page,
          selected: !!pageDataFromBackend, // Set selected to true if the page exists in the data from the backend
          options: page.options.map((option) => ({
            ...option,
            selected: pageDataFromBackend ? pageDataFromBackend.permissions.includes(option.name) : false
          }))
        };
      });

      setPermissionData(updatedPermissions);
    }
  }, [workerData])

  // Create
  const [updateWorker, { error, loading }] = useMutation(UpdateWorker, {
    refetchQueries: [{
      query: ALL_WORKERS,
      variables: { idStore: storeData?.id }
    }]
  });

  const getSelectedPermissions = () => {
    const selectedPermissions = [];

    for (const permission of permissionData) {
      if (permission.selected) {
        selectedPermissions.push({
          name: permission.name,
          permissions: permission.options.filter((option) => option.selected).map((option) => option.name)
        });
      } else {
        const selectedOptions = permission.options.filter((option) => option.selected);
        if (selectedOptions.length > 0) {
          selectedPermissions.push({
            name: permission.name,
            permissions: selectedOptions.map((option) => option.name)
          });
        }
      }
    }

    return selectedPermissions;
  };


  const submit = (e: any) => {
    e.preventDefault();

    if (name === "") {
      setFailMsg(t('emptyClientNameAlert'));
      setFail(true);
      return
    }

    if (email === "") {
      setFailMsg(t('emptyEmailAlert'));
      setFail(true);
      return
    }

    const selectedPermissions = getSelectedPermissions();

    updateWorker({
      variables: {
        updateWorkerId: workerId,
        content: {
          email: email,
          name: name,
          phone: phone,
          idStore: storeData.id,
          permissions: selectedPermissions
        }
      }
    })

    if (!error) {
      setSuccessMsg(t('succUpdateToTeam'));
      setSuccess(true);
    }
  }

  return (
    <section className='mx-3 my-4 md:mx-7'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      <div className='flex flex-col-reverse md:flex-row md:justify-between md:items-center'>
        <div>
          <h3 className='text-2xl font-semibold'>{t('ُeditMember')}</h3>
        </div>
        <div>
          <Breadcrumbs />
        </div>
      </div>

      {initialLoading ?
        <LoadingWidget />
        :
        permissions.edit === false ?
          <PermissionsError />
          :
          <form className='relative px-5 py-2 my-2 bg-white rounded-md' onSubmit={(e) => e.preventDefault}>
            {
              loading || WorkerLoading &&
              <div className='absolute top-0 left-0 z-30 flex items-center justify-center w-full h-full py-10 bg-white/70'>
                <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
              </div>
            }
            <div className='grid gap-4 mb-2 grid-flow-col-1 sm:grid-cols-2'>
              <div>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">{t('name')}</label>
                <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('name')} />
              </div>
              <div>
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">{t('email')}</label>
                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('email')} />
              </div>
            </div>
            <div>
              <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900">{t('phone')}</label>
              <input type="text" id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary outline-none block w-full p-2.5" placeholder={t('phone')} />
            </div>

            <div>
              <div className='flex items-center gap-2 pt-3'>
                <div className='flex'>
                  <input type="checkbox" checked={checkAll} onChange={handleCheckAll} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                  <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <p className='font-semibold'>{t('checkAll')}</p>
              </div>

              <div className='grid items-start grid-cols-3 gap-5 py-5'>
                {permissionData.map((permission, permissionIndex) => (
                  <div key={permissionIndex} className='border rounded'>
                    <div className='flex items-center gap-2 px-3 pt-3'>
                      <div className='flex'>
                        <input type="checkbox" checked={permission.selected} onChange={() => handlePermissionSelect(permissionIndex)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                        <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                      <p className='font-semibold'>{t(permission.name)}</p>
                    </div>

                    <div className='px-3 pt-5 pb-2'>
                      {permission.options.map((option, index) => (
                        <div key={index} className='flex flex-col'>
                          <div className='flex items-center gap-2'>
                            <div className='flex'>
                              <input type="checkbox" checked={option.selected} onChange={() => handlePermissionOptionSelect(permissionIndex, index)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                              <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                            </div>
                            <p>{t(option.name)}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='flex justify-end pt-5'>
              <button onClick={(e) => { submit(e) }} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
                  <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"></path>
                </svg>

                <span className="mx-2">
                  {t('save')}
                </span>
              </button>
            </div>
          </form>
      }
    </section>
  )
}

export default EditWorker